import { render, staticRenderFns } from "./StoryPlayer.vue?vue&type=template&id=23218f1a"
import script from "./StoryPlayer.vue?vue&type=script&lang=js"
export * from "./StoryPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports